import { store } from '@/store/store';
import axios from 'axios';
import { getsrv } from '@/services/api';
export async function getconfig(cfile: string) {
  // 同步请求
  let resultData = null;
  try {
    const res = await axios({
      url: cfile,
      method: 'post',
    }).then(res => {
      console.log('======res',res);
      
      resultData = res.data.config;
      if (store.state.config.ismobile) {
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          window.location = store.state.config.mobile as any;
        }
      }
    });
    store.state.config = resultData;
    var csrv = sessionStorage.getItem('dc-srv');
    if (csrv) {
      let res = JSON.parse(csrv)
      if (res.img && res.img != '') store.state.config.img = res.img;
      if (res.file && res.file != '') store.state.config.file = res.file;
      if (res.infile && res.infile != '') store.state.config.infile = res.infile;
      if (res.upfile && res.upfile != '') store.state.config.upfile = res.upfile;
    }
  } catch (err) {
    console.log(err);
  }
  return resultData;
};